import styled from 'styled-components';
import { font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Container = styled.div`
  .banner-link {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    height: 20px;
    width: 100px;
  }
`;

export const Text = styled.span<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-size: 14px;
  line-height: 16.8px;
  color: ${getColor('neutralDarkGray')};
  margin-right: 8px;
  text-transform: uppercase;
`;
